module.exports = __webpack_public_path__ + "media/blackboxSC.eb58e5b9.mp4";